module.exports = __webpack_public_path__ + "img/arena.247fbbd3.jpg";